import React, { useEffect, useState } from 'react'
import { getCustomTourById, addPayment, editCustomTourCutsomer } from '../../../../../../redux/api/userTour.api'
import { Modal, notification, Tabs } from 'antd'

import './styles.scss'
import BookingDetails from './BookingDetails'
import BookingAccommodations from './BookingAccommodations'
import BookingPayments from './BookingPayments'
import LoadingComp from '../../../../../components/LoadingComp'
import BookingItinery from './BookingItinery'
import TravelerDetails from './TravelerDetails'
import CustomTourChat from './CustomTourChat'
import { checkewayPayment } from '../../../../../../redux/api/payment.api'
import { useNavigate } from 'react-router-dom'
import { CloseCircleFilled, InfoCircleFilled } from '@ant-design/icons'

const CustomEvent = () => {
    const url = window.location.pathname
    const tourId = url.split('/').pop()
    const [userTour, setUserTour] = useState(null)
    const [loading, setLoading] = useState(false)
    const [messageApi, contextHolder] = notification.useNotification();
    const [activeKey, setActiveKey] = useState('1')
    const [processingPayment, setProcessingPayment] = useState(false);
    const [paymentError, setPaymentError] = useState({
        type: null,
        title: null,
        message: null,
    });
    const navigate = useNavigate()

    useEffect(() => {
        handleGetUserTour()
    }, [])

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const accessCode = urlParams.get('AccessCode');
        const tourId = urlParams.get('tourId');
        const amount = urlParams.get('amount');
        const currency = urlParams.get('currency');
        if (accessCode && tourId && amount && currency && userTour) {
            setProcessingPayment(true);
            const beforeUnload = (e) => {
                e.preventDefault();
                e.returnValue = 'Payment is processing. Please do not close or navigate away.';
            };
            window.onbeforeunload = beforeUnload;
            (async () => {
                try {
                    const paymentCheckRes = await checkewayPayment(accessCode);
                    
                    let paymentStatus = 'FAILED';
                    let shouldUpdateTour = false;
                    
                    if (paymentCheckRes?.data?.success && paymentCheckRes?.data?.transactionStatus) {
                        paymentStatus = 'COMPLETED';
                        shouldUpdateTour = true;
                    }

                    const now = new Date();
                    const paymentData = {
                        userId: userTour.userId,
                        paidFor: 'CUSTOM_EVENT',
                        paymentType: 'FULL',
                        paymentMethod: 'CARD',
                        paymentStatus: paymentStatus,
                        paymentAmount: amount,
                        paymentCurrency: currency,
                        paymentDate: now.toISOString().split('T')[0],
                        paymentTime: now.toTimeString().split(' ')[0],
                        paymentReference: tourId,
                        paymentGateway: 'EWAY',
                        paymentGatewayId: accessCode,
                        paymentGatewayResponse: JSON.stringify({ accessCode }),
                        paymentGatewayStatus: paymentStatus === 'COMPLETED' ? 'SUCCESS' : 'FAILED',
                        paymentGatewayReference: accessCode,
                        paymentGatewayAmount: amount,
                        paymentGatewayCurrency: currency,
                        paymentGatewayDate: now.toISOString().split('T')[0],
                        paymentGatewayTime: now.toTimeString().split(' ')[0],
                        paymentGatewayDescription: `Payment for custom event booking ${tourId}`,
                    };
                    const paymentRes = await addPayment(paymentData);

                    if (shouldUpdateTour) {
                        if (paymentRes.status === 201 || paymentRes.status === 200) {
                            const updateRes = await editCustomTourCutsomer({
                                id: tourId,
                                paymentStatus: 'COMPLETED',
                                bookingStatus: 'COMPLETED',
                                paymentId: paymentRes?.data?.id,
                                paidAt: now.toISOString(),
                                paymentMethod: 'CARD',
                            });
                            if (updateRes.status === 200) {
                                messageApi.success({ type: 'success', message: 'Payment Successful', description: 'Your payment and booking update were successful.' });
                            } else {
                                setPaymentError({
                                    type: 'error',
                                    title: 'Error Updating Booking',
                                    message: `Payment was successful, but booking update failed. Please contact support.`
                                })
                            }
                        } else {
                            setPaymentError({
                                type: 'error',
                                title: 'Payment Recording Failed',
                                message: `Payment was successful, but booking update failed. Please contact support.`
                            })
                        }
                    } else {
                        setPaymentError({
                            type: 'error',
                            title: 'Payment Failed',
                            message: 'Payment was unsuccessful. Please try again or contact support.'
                        })
                    }
                } catch (error) {
                    setPaymentError({
                        type: 'error',
                        title: 'Payment Processing Error',
                        message: 'An error occurred while processing your payment. Please contact support.'
                    })
                }

                window.onbeforeunload = null;
                setProcessingPayment(false);
                await handleGetUserTour();
                window.history.replaceState({}, document.title, window.location.pathname);
            })();
        }
        // eslint-disable-next-line
    }, [window.location.search, userTour]);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = 'Payment is processing. Are you sure you want to leave? This may result in payment or booking not being completed.';
            return e.returnValue;
        };
        if (processingPayment) {
            window.addEventListener('beforeunload', handler);
            return () => {
                window.removeEventListener('beforeunload', handler);
            };
        } else {
            window.removeEventListener('beforeunload', handler);
        }
    }, [processingPayment]);

    const handleGetUserTour = async () => {
        setLoading(true)
        try {
            const response = await getCustomTourById(tourId)
            setUserTour(response.data)
        } catch (error) {
            console.log('ERROR GETTING USER TOUR', error)
        }
        setLoading(false)
    }


    const items = [
        {
            key: '1',
            label: 'Booking Details',
            children: <BookingDetails userTour={userTour} handleGetUserTour={handleGetUserTour} messageApi={messageApi} />
        },
        {
            key: '2',
            label: 'Traveler Details',
            children: <TravelerDetails userTour={userTour} handleGetUserTour={handleGetUserTour} messageApi={messageApi} />
        },
        {
            key: '3',
            label: 'Tour Accommodation',
            children: <BookingAccommodations userTour={userTour} />
        },
        {
            key: '4',
            label: 'Payments',
            children: <BookingPayments userTour={userTour} />
        },
        {
            key: '5',
            label: 'Itinerary',
            children: <BookingItinery userTour={userTour} handleGetUserTour={handleGetUserTour} setActiveKe={setActiveKey} messageApi={messageApi} />
        },
        {
            key: '6',
            label: 'Chat',
            children: <CustomTourChat userTour={userTour} messageApi={messageApi} />
        },
    ]

    return (
        <div className='personal_details tour_booking_details_container'>
            {contextHolder}
            {!loading ? <>
                <h1 className='heder_2'>
                    {userTour?.packageName}
                </h1>
                <div className='tour_booking_details'>
                    <Tabs
                        defaultActiveKey={activeKey}
                        items={items}
                    />
                </div>
            </>
                :
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh'
                    }}
                >
                    <LoadingComp />
                </div>
            }
            {processingPayment && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255,255,255,0.95)',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <LoadingComp />
                    <div style={{ marginTop: 24, fontSize: 20, color: '#333', fontWeight: 500 }}>
                        Processing your payment. Please do not close or navigate away.
                    </div>
                </div>
            )}

            <Modal
                open={paymentError.type}
                onCancel={() => {
                    setPaymentError({
                        type: null,
                        title: null,
                        message: null,
                    })
                    navigate('/dashboard/my-bookings/tours');
                }}
                footer={null}
                width={450}
                centered
                >
                <div className='payment_error'>
                    <div className='payment_error_title'
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <div className='payment_error_title_icon'>
                            {
                                paymentError.type === 'error' ? (
                                    <CloseCircleFilled style={{ color: 'red' , fontSize: 25, marginRight: 10 }} />
                                ) : (
                                    <InfoCircleFilled style={{ color: 'red' , fontSize: 25, marginRight: 10 }} />
                                )
                            }
                        </div>
                        <div className='payment_error_title_text'>
                            <h3>{paymentError.title}</h3>
                        </div>
                    </div>

                    <p>{paymentError.message}</p>
                </div>
            </Modal>
        </div>
    )
}

export default CustomEvent